import PropTypes from 'prop-types';

/** Shape for Access Pass */
export const AccessPass = {
  aporType: PropTypes.string,
  company: PropTypes.string,
  controlCode: PropTypes.string,
  destCity: PropTypes.string,
  destName: PropTypes.string,
  destProvince: PropTypes.string,
  destStreet: PropTypes.string,
  email: PropTypes.string,
  id: PropTypes.string,
  identifierNumber: PropTypes.string,
  idType: PropTypes.string,
  name: PropTypes.string,
  notified: PropTypes.boolean,
  originCity: PropTypes.string,
  originName: PropTypes.string,
  originProvince: PropTypes.string,
  originStreet: PropTypes.string,
  passType: PropTypes.string,
  plateNumber: PropTypes.string,
  referenceId: PropTypes.string,
  remarks: PropTypes.string,
  status: PropTypes.string,
  updates: PropTypes.string,
};
